import { create } from "zustand";
import { articlesService } from "@/services/articles";

interface ArticleCountStore {
  unreadCount: number;
  fetch: (workspaceId: string) => Promise<void>;
  decrementBy: (n: number) => void;
  incrementBy: (n: number) => void;
}

export const useArticleCountStore = create<ArticleCountStore>((set) => ({
  unreadCount: 0,

  fetch: async (workspaceId: string) => {
    try {
      const data = await articlesService.unreadCounts(workspaceId);
      set({ unreadCount: data.total });
    } catch {
      // Non-critical — silently fail
    }
  },

  decrementBy: (n: number) => set((state) => ({ unreadCount: Math.max(0, state.unreadCount - n) })),

  incrementBy: (n: number) => set((state) => ({ unreadCount: state.unreadCount + n })),
}));
